import React, { useState } from 'react';
import MenuList from './MenuList';

const Operations = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <div className='flex flex-col h-screen'>
      <div className='flex items-center py-2 w-[87%]'>
        <MenuList isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <h1 className='text-2xl text-orange-600'>Operations</h1>
      </div>
      <div className='flex-1 overflow-hidden mx-auto w-[100%]'>
        <iframe
          title='report'
          width='100%'
          height='100%'
          src='https://lookerstudio.google.com/embed/u/0/reporting/8390c9a8-a2f7-4984-a854-a5a6827a8765/page/WosKF'
          frameBorder='0'
          style={{ border: '0', margin: 'auto' }}
          allowFullScreen
          sandbox='allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
        ></iframe>
      </div>
    </div>
  );
};

export default Operations;
